module.exports = __webpack_public_path__ + "img/challenge-accepted.f8291dab.png";